import {
    ANDROID_AGENT,
    STANDARD_MOBILE_AGENTS,
    EXTENDED_MOBILE_AGENTS,
    IOS_MOBILE_AGENTS,
    TABLET_AGENTS
} from './constants';

export const isMac = (userAgent: string): boolean => {
    const ua = userAgent ? userAgent : navigator?.userAgent || '';
    const versionIndex = ua.indexOf('Version/');
    const version = ua.substring(versionIndex + 8, versionIndex + 12);

    return ua.indexOf('Macintosh') > -1 || (+version >= 13 && ua.indexOf('iPad') > -1);
};

export const isIos = (userAgent: string): boolean => {
    if (userAgent) {
        return IOS_MOBILE_AGENTS.test(userAgent);
    }

    if (typeof navigator !== 'undefined' && navigator && navigator.userAgent) {
        return IOS_MOBILE_AGENTS.test(navigator.userAgent);
    }

    return false;
};

export const isMobileFlag = (userAgent: string): boolean => {
    const isMobileAgent = STANDARD_MOBILE_AGENTS.test(userAgent);
    const isExtMobileAgent = EXTENDED_MOBILE_AGENTS.test(userAgent.substr(0, 4));
    const isIosMobileAgent = IOS_MOBILE_AGENTS.test(userAgent);
    const isAndroidMobileAgent = userAgent.includes(ANDROID_AGENT);

    return isMobileAgent || isExtMobileAgent || isIosMobileAgent || isAndroidMobileAgent;
};

/**
 * @deprecated
 */
export const isMobile = (userAgent?: string): boolean => {
    let ua = userAgent;
    if (typeof navigator !== 'undefined' && navigator?.userAgent && !ua) {
        ua = navigator.userAgent;
    }

    /**
     * If no user-agent is defined return true
     * excerpt from https://gitlab.app.betfair/Gaming-Frontend/gfe-website/merge_requests/1644:
     *     One of the use cases for this, is that in Sports Wrapper the User-Agent is changed,
     *     and that it might be corrupted. So, in the future, if they will decide that they won't send an UA,
     *     then we'll be in the situation of not showing anything on the X-Sell pages.
     */
    if (!ua) {
        return true;
    }

    if (isMac(ua)) {
        return false;
    }

    return isMobileFlag(ua);
};

/**
 * @deprecated
 */
export const isTablet = (userAgent?: string): boolean => {
    let ua = userAgent;
    if (typeof navigator !== 'undefined' && navigator?.userAgent && !ua) {
        ua = navigator.userAgent;
    }

    return TABLET_AGENTS.test(ua!);
};
